import {
  createStyleMixin,
  draggableMixin,
  componentNameValidationMixin,
} from '@descope-ui/common/components-mixins';
import { compose } from '@descope-ui/common/utils';
import {
  getComponentName,
  forwardAttrs,
  injectStyle,
} from '@descope-ui/common/components-helpers';
import { createBaseClass } from '@descope-ui/common/base-classes';
import { TextClass } from '@descope-ui/descope-text/class';

export const componentName = getComponentName('link');

class RawLink extends createBaseClass({ componentName, baseSelector: ':host a' }) {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' }).innerHTML = `
		<div>
			<descope-text part="wrapper">
				<a>
					<slot></slot>
				</a>
			</descope-text>
		</div>
		`;

    injectStyle(
      `
    :host {
			display: inline-block;
      line-height: 1em;
		}
		:host a {
			display: inline;
		}

    :host([ellipsis="true"]) descope-text {
      display: inline-flex;
    }
    :host([ellipsis="true"]) descope-text::part(text-wrapper) {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
      `,
      this
    );

    forwardAttrs(this, this.shadowRoot.querySelector('a'), {
      includeAttrs: ['href', 'target', 'tooltip'],
      mapAttrs: {
        tooltip: 'title',
      },
    });

    forwardAttrs(this, this.shadowRoot.querySelector('descope-text'), {
      includeAttrs: ['mode', 'variant'],
    });
  }
}

const selectors = {
  host: { selector: () => ':host' },
  link: { selector: () => ':host a' },
  anchor: {},
  wrapper: { selector: () => ':host > div' },
  text: { selector: () => TextClass.componentName },
};

const { anchor, text, host, wrapper, link } = selectors;

export const LinkClass = compose(
  createStyleMixin({
    mappings: {
      hostWidth: { ...host, property: 'width' },
      hostDirection: { ...text, property: 'direction' },
      textAlign: wrapper,
      textDecoration: { ...link, property: 'text-decoration', fallback: 'none' },
      textColor: [
        { ...anchor, property: 'color' },
        { ...text, property: TextClass.cssVarList.textColor },
      ],
      cursor: anchor,
    },
  }),
  draggableMixin,
  componentNameValidationMixin
)(RawLink);
